var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{attrs:{"src":"http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/404.svg"}}),_vm._m(0),_c('button',{staticClass:"home",on:{"click":_vm.goHome}},[_vm._v("前往首页")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_vm._v("该页面不存在 "),_c('br'),_vm._v("或无权访问 "),_c('br'),_vm._v("请检查后重试")])
}]

export { render, staticRenderFns }